import { PhoneAuthForm } from './PhoneAuthForm';

interface Props {
  onGoLogin: () => void;
  onSuccess: () => void;
}

export function PhoneRegisterScreen({ onGoLogin, onSuccess }: Props) {
  return (
    <PhoneAuthForm variant="register" onSwitchVariant={onGoLogin} onSuccess={onSuccess} />
  );
}
